import React from "react";
import image from "../assets/FahimShariar-About-Section.jpg";

const About = () => {
  return (
    <div
      name="about"
      className=" bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="">
          <h1 className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </h1>
        </div>
        <div className="md:flex justify-center items-center gap-5 py-8">
          <div className="md:w-1/2">
            <img className="rounded-xl" src={image} alt="" />
          </div>
          <div className="md:w-1/2 text-xl">
            <p>
              Hello! I'm Fahim Shariar, from Bangladesh. I am dedicated to
              learning and mastering new technologies, and coding has become my
              true passion.
            </p>
            <p>
              I invest a significant amount of time in staying up-to-date with
              the latest trends and honing my skills. If you have an exciting
              project in mind, I'm all ears! Feel free to explore my resume to
              gain a better understanding of my skills and experience. Let's
              connect and bring your project to life together!
            </p>
            <a
              className="btn btn-primary mt-3"
              href="https://drive.google.com/u/0/uc?id=1YYa2YxefZGmWpB0KrsUBEoBmmem_DYEV&export=download"
            >
              Download Resume
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
